import Axios from 'axios';
import axios, { getEnv } from "../../../services/api";

export const VersaoAppService = {
    
    findAll: async (params, body = {}, source) => {
        try {
            const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v2/stores/consultar`, body, {
                params,
                cancelToken: source?.token
            });
            return response.data;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada', error.message);
            } else {
                console.log(error.message);
                throw error;
            }
        }
    },
    
    find: async (idVersao) => {
        const params = {idVersao}
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v2/stores`, {params})
            return response.data;
        } catch (error) {
            return error;
        }
    },
    
    save: async (body) => {
        const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v2/stores`, body);
        return response.data;
        
    },
    
    update: async (body) => {
        // try {
        return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v2/stores`, body);
        // } catch (error) {
        //     return error;
        // }
    },
    
    changeStatus: async (idVersao, status) => {
        const params = {idVersao, status};
        try {
            return await axios.put(`${await getEnv('REACT_APP_URL_SERVICE')}/v2/stores/alterar-status`, {}, {params});
        } catch (error) {
            throw error;
        }
    },
    delete: async (idVersao) => {
        const params = {idVersao};
        try {
            return await axios.delete(`${await getEnv('REACT_APP_URL_SERVICE')}/v2/stores`, {params});
        } catch (error) {
            return error;
        }
    },
    
    getFilterOptions: async () => {
        try {
            const response = await axios.get(`${await getEnv('REACT_APP_URL_SERVICE')}/v2/stores/opcoes`);
            return response.data
        } catch (error) {
            return error;
        }
    },
    
    searchInput: async (body, params, source) => {
        const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v2/stores/consultar`, body,
            {
                params,
                cancelToken: source?.token
            });
        source.cancel('Operação cancelada pelo usuário');
        return response.data;
    },
    getPedants: async (body = {}, source) => {
        try {
            const response = await axios.post(`${await getEnv('REACT_APP_URL_SERVICE')}/v2/stores/buscar-pendentes`, body, {
                cancelToken: source?.token
            });
            return response.data;
        } catch (error) {
            if (Axios.isCancel(error)) {
                console.log('Requisição cancelada', error.message);
            } else {
                console.log(error.message);
                throw error;
            }
        }
    }
}

